import type { Laeringsaktivitet, MittVerktoyItem, Verktoy, LaeringsaktivitetV2 } from './minhelseentities';

import type { HelsenorgeHttpError, HelsenorgeProxyError } from '@helsenorge/framework-utils/hn-proxy-service';


export const VERKTOY_PROXY_NAME = 'verktoynetcore';
export const SCOPE_VERKTOYUTFORELSE = 'verktoyutforelse';

export interface GetVerktoyListeOperationResponse extends Response {
  Verktoyliste: Verktoy[];
}

export interface GetMineVerktoyListeOperationResponse extends Response {
  Verktoy: MittVerktoyItem[];
}

export interface GetMittVerktoyByGuidResponse extends Response {
  LaeringsaktivitetV2: LaeringsaktivitetV2;
}

export interface GetVerktoyOperationResponse extends Response {
  Verktoy: Verktoy;
}

export interface GetVerktoyLaunchOperationResponse extends Response {
  LaunchScript: string;
  RedirectUrl: string | null;
}

export interface AddLaeringsaktivitetOperationRequest {
  VerktoyId: string;
  OppgaveId?: string;
}

export interface AddLaeringsaktivitetOperationResponse extends Verktoy {
  Laeringsaktivitet: Laeringsaktivitet;
}

export interface DeleteLaeringsaktivitetRequest {
  LaeringsaktivitetId: number;
}

export interface AvvisOppgaveRequest {
  OppgaveId: string;
  VerktoyId: string;
}

export type AvvisOppgaveResponse = Response;

export type VerktoyProxyErrorResponse = HelsenorgeProxyError | HelsenorgeHttpError | Error;

export enum HttpStatusCode {
  not_found = '404',
}